export default __webpack_public_path__ + "static/media/c.2168b738.svg";